import { Component, Input } from '@angular/core';
import { IFilterProfile } from '@interfaces/tankProfile';
import { capitalizeFirstLetter } from '@utils/utils';

@Component({
  selector: 'app-filter-profile-display',
  templateUrl: './filter-profile-display.component.html',
  styleUrls: ['./filter-profile-display.component.scss']
})
export class FilterProfileDisplayComponent {
  @Input() filterProfile: IFilterProfile;
  @Input() filterModel: any;

  get filters() {
    return Object.keys(this.filterModel || {});
  }

  formatFilterName(filterColumnName: string) {
    switch (filterColumnName) {
      default:
        return `Column.${capitalizeFirstLetter(filterColumnName)}`;
    }
  }
} 